import { Coverage } from "@graphql/api";
import { mapPolicyType } from "@redux/residents/utils";
import { mapInsuranceCarrierName } from "@utils";

export const getCoverageItemTitle = (coverage: Coverage): string =>
  `${mapPolicyType(coverage.policyType)}, ${mapInsuranceCarrierName(
    coverage.insuranceCarrierName
  )}, ${coverage.policyId}`;

export default getCoverageItemTitle;
